/** Conversion between the dd-mm-yyyy text people type and the YYYY-MM-DD value a
 *  native date input carries. Kept out of the component so it can be tested
 *  without a JSX toolchain. */

/** "2026-08-13T14:30" -> "13-08-2026 14:30" */
export function display(value: string, withTime: boolean): string {
  if (!value) return "";
  const [datePart, timePart] = value.split("T");
  const parts = (datePart ?? "").split("-");
  if (parts.length !== 3) return "";
  const day = `${parts[2]}-${parts[1]}-${parts[0]}`;
  return withTime && timePart ? `${day} ${timePart.slice(0, 5)}` : day;
}

/** "13-08-2026 14:30", "13/08/2026" and "13.08.2026" all parse. Returns null for
 *  anything that is not a real calendar date, so the field can restore itself. */
export function parse(raw: string, withTime: boolean): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const match = /^(\d{1,2})[-/. ](\d{1,2})[-/. ](\d{4})(?:[ T](\d{1,2}):(\d{2}))?$/.exec(trimmed);
  if (!match) return null;
  const day = Number(match[1]), month = Number(match[2]), year = Number(match[3]);
  const hour = match[4] === undefined ? 0 : Number(match[4]);
  const minute = match[5] === undefined ? 0 : Number(match[5]);
  if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return null;
  const probe = new Date(year, month - 1, day);
  if (probe.getFullYear() !== year || probe.getMonth() !== month - 1 || probe.getDate() !== day) return null;
  const pad = (part: number) => String(part).padStart(2, "0");
  const date = `${year}-${pad(month)}-${pad(day)}`;
  return withTime ? `${date}T${pad(hour)}:${pad(minute)}` : date;
}
